import React, {FC, useRef} from 'react'
import {KTSVG} from '../../helpers'
import {FormikHelpers, useFormik} from 'formik'
import * as Yup from 'yup'
import {Post} from '../../../setup'
import "./styles.css"
import {useNotifications, useProducts} from '../../../app/@contexts'
import {StripHtml, useStatusMessage} from '../../../app/features'

const REQUEST_A_PRODUCT = process.env.REACT_APP_REQUEST_A_PRODUCT || 'demand-infos'

const Schema = Yup.object().shape({
    first_name: Yup.string().min(3, 'Au moins 3 lettres').max(15, 'Maximum 15 lettres'),
})

type initialValuesType = {
    message: string,
    products: string,
}

type Props = {
    index: number
    name: string
    productKey: string
    description: string
}

const RequestAProduct: FC<Props> = ({index, name, productKey, description}) => {

    const modalRef = useRef<HTMLDivElement | null>(null)
    const closeRef = useRef<HTMLButtonElement | null>(null)
    const {formState, setLoading} = useStatusMessage()
    const {setToast} = useNotifications()
    const {triggerReload} = useProducts()

    const onSubmit = async (
        values: initialValuesType,
        {setSubmitting}: FormikHelpers<initialValuesType>,
    ) => {

        setLoading(true)
        setSubmitting(false)

        try {

            const {status} = await Post<{status: number}>(REQUEST_A_PRODUCT, values)
            if (status === 200) {
                setTimeout(() => {
                    setToast({
                        type: 'success',
                        text: {
                            title: 'Demande de devis',
                            message: 'produits demandés avec succès',
                        },
                    })
                    triggerReload()
                    formik.resetForm()
                    closeRef.current?.click()
                }, 1000)
            }

        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
            setSubmitting(false)
        }
    }


    const formik = useFormik({
        initialValues: {
            message: productKey,
            products: productKey,
        },
        validationSchema: Schema,
        enableReinitialize: true,
        onSubmit,
    })


    return (
        <>
            <div className="text-center">
                <button type="button"
                        className="btn btn-sm btn-light-primary btn-flex btn-active-primary"
                        data-bs-toggle="modal"
                        data-bs-target={`#kt_modal_request_a_product_${index}`}
                        aria-describedby="control-id-click"
                >
                    <KTSVG path="/media/icons/duotune/general/gen044.svg"
                           className="svg-icon-1 svg-icon-gray-500 me-1"
                    />
                    Demande de devis
                </button>
            </div>

            <div className="modal fade" id={`kt_modal_request_a_product_${index}`} aria-hidden="true" ref={modalRef}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="modal-header">
                                <h2>{name}</h2>
                                <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
                                </div>
                            </div>
                            <div className="modal-body p-3 p-sm-5  p-md-7">
                                <div className="d-flex flex-wrap mb-4 fs-6 text-gray-800">
                                    {StripHtml(description)}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-sm btn-primary me-2 px-6"
                                        disabled={formState.loading}>
                                    {formState.loading ? (
                                        <span className="indicator-progress d-block">
                                            S'il vous plaît, attendez... <span
                                            className="spinner-border spinner-border-sm align-middle ms-2" />
                                        </span>
                                    ) : (
                                        'Demande'
                                    )}
                                </button>
                                <button type="button"
                                        className="btn btn-sm btn-light me-2 px-6"
                                        data-bs-dismiss="modal"
                                        onClick={() => formik.resetForm()}
                                        ref={closeRef}
                                >
                                    Fermer
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export {RequestAProduct}